import { Dto } from '../../../data/dto/dto';
import { DTO_DEFAULT, DtoType } from '../../../data/dto/dto-types';
import {
    DtoExport,
    DtoForceConstructor,
    DtoImport,
} from '../../../utils/dto';
import { DeliveryZoneModel } from '../delivery-zone-model';
import { DispatchConfigSchema } from './dispatch-config.schema';

@DtoForceConstructor
export class DispatchConfig {
    id: string;
    deliveryRadius: number; // meters
    deliveryZoneModel?: DeliveryZoneModel;
    deliveryZonePolyline?: string;
    autoAssign: boolean;
    allowSnooze: boolean;
    undeliverableAction: string;
    driverPositionIds: string[];
    maxOrders: number;
    offerTimeoutSeconds: number; // in seconds

    @DtoImport(DispatchConfigSchema)
    static import(dto: Dto): any {}

    constructor(value?: {
        id?: string;
        deliveryRadius: number;
        deliveryZoneModel: DeliveryZoneModel;
        deliveryZonePolyline: string;
        autoAssign: boolean;
        allowSnooze: boolean;
        driverPositionIds: string[];
        maxOrders: number;
        offerTimeoutSeconds: number;
    }) {
        if (value) {
            this.id = value.id;
            this.deliveryRadius = value.deliveryRadius;
            this.deliveryZoneModel = value.deliveryZoneModel;
            this.deliveryZonePolyline = value.deliveryZonePolyline;
            this.autoAssign = value.autoAssign;
            this.allowSnooze = value.allowSnooze;
            this.driverPositionIds = value.driverPositionIds;
            this.maxOrders = value.maxOrders;
            this.offerTimeoutSeconds = value.offerTimeoutSeconds;
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DispatchConfigSchema,
        },
    ])
    export(type?: DtoType): any {}
}
